import { makeAPICall, scanApiCall } from '../../utils/ApiCall';

import {store} from './../../configureStore'
import config from '../../utils/config'
import { JSEncrypt } from "jsencrypt";
import sha256 from 'js-sha256';
import { v4 as uuid } from 'uuid';
import { toast } from 'react-toastify';
// import axios from "axios";
import base64 from 'base-64';

export const SEND_OTP_SUCCESS = 'SEND_OTP_SUCCESS';
export const VERIFY_OTP_SUCCESS = "VERIFY_OTP_SUCCESS";
export const BILL_CHOICE = "BILL_CHOICE";
export const CHANGE_HOMETAB = "CHANGE_HOMETAB"
export const HIDE_NAVBAR = "HIDE_NAVBAR"
export const CONSENT_GROUP_ELEMENT = "CONSENT_GROUP_ELEMENT";
export const CONSENT_GROUP_ELEMENT_FROM_DASHBOARD =  "CONSENT_GROUP_ELEMENT_FROM_DASHBOARD";

export const GET_TEMPLATE = "GET_TEMPLATE"
export const GET_DATATYPE = "GET_DATATYPE"
export const GET_PURPOSE = "GET_PURPOSE"
export const CLIENT_SWITCHED = "CLIENT_SWITCHED";
export const DASHBOARD_DATA_DSR = "DASHBOARD_DATA_DSR"

export const DASHBOARD_DATA = "DASHBOARD_DATA"
export const TEMPLATE_DETAIL = "TEMPLATE_DETAIL"
export const CONSENT_DETAIL = "CONSENT_DETAIL"
export const PROFILE_DATA = "PROFILE_DATA"
export const APP_LOGO = "APP_LOGO"
export const APP_NAME = "APP_NAME"

export const CREATE_TEMPLATE = "CREATE_TEMPLATE"
export const CREATE_DATATYPE = "CREATE_DATATYPE"
export const CREATE_PURPOSE = "CREATE_PURPOSE"
export const GET_ENTITY = "GET_ENTITY"
export const ONBOARD_TEMPLATE = "ONBOARD_TEMPLATE"

export const LOG_OUT = "LOG_OUT"
export const CONSENT_SESSION = "CONSENT_SESSION"
export const CLEAR_SESSION = 'CLEAR_SESSION';
export const GENERATE_TOKEN = "GENERATE_TOKEN"
export const SAVE_AUTH_TOKEN = "SAVE_AUTH_TOKEN"
export const CONSENT_DATA_ARRAY = "CONSENT_DATA_ARRAY"
export const SAVE_BLOCKCHAIN_AUTH_TOKEN = "SAVE_BLOCKCHAIN_AUTH_TOKEN"
export const UUID_TXN = "UUID_TXN"

export const GET_PREFERENCE_CENTER_DATA = "GET_PREFERENCE_CENTER_DATA"

export const PRODUCT_THEME = "PRODUCT_THEME"
export const GET_PRODUCT_THEME = "GET_PRODUCT_THEME"
export const GET_FAQ_DATA = "GET_FAQ_DATA"
export const GET_CONSENT_GROUP_DATA = "GET_CONSENT_GROUP_DATA"
export const GET_CONSENTGROUPDATABY_GROUPID = "GET_CONSENTGROUPDATABY_GROUPID"
export const GET_TEMPLATE_DETAIL_BY_TEMPLATEID ="GET_TEMPLATE_DETAIL_BY_TEMPLATEID"
export const UPDATE_CONSENT_GROUP = "UPDATE_CONSENT_GROUP"
export const SCANNED_COOKIE_DATA = "SCANNED_COOKIE_DATA"
export const SCANNED_COOKIE_RESP = "SCANNED_COOKIE_RESP"
export const COOKIE_DETAIL_WITH_DESCRIPTION = "COOKIE_DETAIL_WITH_DESCRIPTION"
export const COOKIE_SCAN_URL = "COOKIE_SCAN_URL"
export const POST_COOKIES_SCAN_REPORT_RESPONSE = "POST_COOKIES_SCAN_REPORT_RESPONSE"
export const COOKIE_CONSENT_LOGS = "COOKIE_CONSENT_LOGS"
export const  CONSENT_VERIFICATION_RESULT= " CONSENT_VERIFICATION_RESULT"
export const CONSENT_LIST = "CONSENT_LIST"
export const BULK_JSON_DATA = "BULK_JSON_DATA"
export const CREATE_BULK_CONSENT_RESPONSE = "CREATE_BULK_CONSENT_RESPONSE"
export const GET_CREATE_CONSENT_GROUP_RESPONSE = "GET_CREATE_CONSENT_GROUP_RESPONSE"
export const TEMPLATE_DETAIL_BY_SELECTED_CONSENTGROUP = "TEMPLATE_DETAIL_BY_SELECTED_CONSENTGROUP";
export const GET_UPDATED_CONSENT_GROUP_RESPONSE = "GET_UPDATED_CONSENT_GROUP_RESPONSE";

var jsencrypt = new JSEncrypt();

let timestamp = new Date().toISOString()
let today = new Date();
let start = today.toISOString();
let end = new Date(today.setFullYear(today.getFullYear() + 1)).toISOString();

// OAuth client_id / client_secret must not be used in the SPA.
// Access tokens are obtained from validateOtp; BFF injects APIM/Azure credentials server-side.
export const generateToken = ()=>{
    return async (dispatch,getState)=>{
        let headers = {}
        let data = {
            "grant_type":"client_credentials",
        }

        try{
            let resp =  await makeAPICall(config.TOKEN, "POST",  data, headers)
            let access_token = resp.data.access_token
            
            if(access_token){
                dispatch({
                    type:SAVE_AUTH_TOKEN,
                    access_token :  access_token
                })
            }
        }
        catch (error) {
            let obj1 = error.errorCd;
            let obj2 = error.errorMsg;
    
            if(obj2!==undefined){
                toast.error(`${obj2}`);
            }else{
                toast.error(`Session Expired: Please login again`);
                sessionStorage.removeItem('sessionId');
                window.location.href = '/login';

            }
        }
       
    }
}

export const generateBlockChainToken = ()=>{
    return async (dispatch,getState)=>{
        let headers = {}
        let data = {
            "grant_type":"client_credentials",
        }

        try{
            let resp =  await makeAPICall(config.TOKEN, "POST",  data, headers)

            let blockchain_access_token = resp.data.access_token
            if(blockchain_access_token){
                dispatch({
                    type:SAVE_BLOCKCHAIN_AUTH_TOKEN,
                    blockchain_access_token :  blockchain_access_token
                })
            }
        }
        catch (error) {
            let obj1 = error.errorCd;
            let obj2 = error.errorMsg;
    
            if(obj2!==undefined){
                toast.error(`${obj2}`);
            }else{
                toast.error(`Session Expired: Please login again`);
                sessionStorage.removeItem('sessionId');
                 window.location.href = '/login';
            }
        }
       
    }
}

export const billChoice = (bill)=>{
    return async (dispatch,getState)=>{
        dispatch({
            type:BILL_CHOICE,
            selectedBill: bill
        })
    }
}

export const transferObject = (consentGroupElement)=>{
    return async (dispatch,getState)=>{
        dispatch({
            type:CONSENT_GROUP_ELEMENT,
            selectedCGE: consentGroupElement
        })
    }
}


export const transferObjectFromDashboard = (consentGroupElement)=>{
    return async (dispatch,getState)=>{
        dispatch({
            type:CONSENT_GROUP_ELEMENT_FROM_DASHBOARD,
            receivedConsentGroup: consentGroupElement
        })
    }
}



export const changeHomeTab = (index)=>{
    return async (dispatch,getState)=>{
        dispatch({
            type:CHANGE_HOMETAB,
            tabIndex: index
        })
    }
}


export const bulkJsonData = (bulkData)=>{
    return async (dispatch,getState)=>{
        dispatch({
            type:BULK_JSON_DATA,
            bulkData: bulkData
        })
    }
}


export const hideNavbar = (val)=>{
    return async (dispatch,getState)=>{
        // console.log('val of paramater ', val)
        let status = val;
        dispatch({
            type:HIDE_NAVBAR,
            status
        })
    }
}

export const logOut = () =>{
    return async (dispatch,getState)=>{
            dispatch({
                type:LOG_OUT
            })
    }
}

export const generateRandomSessionId = (length) => {
   // alert("Alert in ramdomseesion id")
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let sessionId = '';
    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        sessionId += characters.charAt(randomIndex);
    }
    return sessionId;
}

export const session = () =>{
    return async (dispatch,getState)=>{
        const newSessionId = generateRandomSessionId(32);
        // Store the session ID in session storage
    sessionStorage.setItem('sessionId', newSessionId);
            dispatch({
                type:CONSENT_SESSION,
                sessionId :  newSessionId
            })
    }
}


export const clearSession = () => ({
    type: CLEAR_SESSION,
  });

export const otpSend = (val)=>{
    //alert("val : "+val);
    return async (dispatch,getState)=>{

         //console.log(`inside otpsend`);
         //console.log(process.env)
         //console.log(process.env.REACT_APP_BASE_URL)

        let access_token = getState().common.access_token;
        let headers = { "Authorization":`Bearer ${access_token}`}
        let request = {
            "clientId":val,
            "idType":"3" 
        }
        let requestForEmail = {
            "clientId":val,
            "idType":"4" 
        }
        
        try{
        // console.log(`inside `, request,config.INIT_OTP);
        
        let resp = await makeAPICall(config.INIT_OTP, "POST", request, headers);
        //console.log("it's here")
        //console.log(`Response sendOtp ${JSON.stringify(resp)}`);
        resp = resp.data
        let mobile = resp.idValue
        let otpTxnId = resp.txnId
        // console.log(`val of mobile ${mobile} and otpTxnId ${otpTxnId}`);

        let respForEmail = await makeAPICall(config.INIT_OTP, "POST", requestForEmail, headers);
        //console.log(`Response for email sendOtp ${JSON.stringify(respForEmail)}`);
        respForEmail = respForEmail.data
        let email = respForEmail.idValue
        let otpTxnIdForEmail = respForEmail.txnId

        
        //alert("email : "+email);
        dispatch({
            type: SEND_OTP_SUCCESS,
            mobile,
            otpTxnId,
            email,
            otpTxnIdForEmail,
            clientId:val
        })
    }catch (error) {
       
        //console.log("ERROR IN ACTION", JSON.stringify(error));
        let obj1 = error.errorCd;
        let obj2 = error.errorMsg;

        //console.log("obj1 & obj2", obj1, obj2);

        if (obj2) {
            
            toast.error(`${obj2}`);
            //setStatus(false);
            return { success: false, message: obj2 };
            
        } else {
            toast.error("Something went wrong, please try again later.");
            //setStatus(false);
            return { success: false, message: "Something went wrong, please try again later." };
           
        }

        
    }
};
}

export const otpVerify = (val, valFromEmail) => {
    return async (dispatch, getState) => {
        let otpTxnId = getState().common.otpTxnId;
        let otpTxnIdForEmail = getState().common.otpTxnIdForEmail;
        let clientId = getState().common.clientId;
        let access_token = getState().common.access_token;
        let headers = { "Authorization": `Bearer ${access_token}` };

        var encOTP = await otpEncryption(val);
        var encOTPFromEmail = await otpEncryption(valFromEmail);
        if (!encOTP && !encOTPFromEmail) {
            throw new Error(`Error in Encrypting otp`);
        }
        let request = {
            "txnId": otpTxnId,
            "userOTP": encOTP,
            "clientId": clientId
        };

        let requestForEmail = {
            "txnId": otpTxnIdForEmail,
            "userOTP": encOTPFromEmail,
            "clientId": clientId
        };

        try {
            let resp = await makeAPICall(config.VERIFY_OTP, "POST", request, headers);
            let data = resp.data;
            let clientSecret = data.clientSecret;

            let respForEmail = await makeAPICall(config.VERIFY_OTP, "POST", requestForEmail, headers);
            let dataForEmail = respForEmail.data;
            let clientSecretForEmail = dataForEmail.clientSecret;
            let access_token = data.access_token;
            dispatch({
                type: VERIFY_OTP_SUCCESS,
                clientSecret: clientSecret,
                clientSecretForEmail: clientSecretForEmail
            });
            if(access_token){
                dispatch({
                    type:SAVE_AUTH_TOKEN,
                    access_token :  access_token
                })
            }
            return { success: true };
        } catch (error) {
            //console.log("ERROR IN ACTION", JSON.stringify(error));
            let obj1 = error.errorCd;
            let obj2 = error.errorMsg;

            //console.log("obj1 & obj2", obj1, obj2);

           if(obj2!==undefined){
        toast.error(`${obj2}`);
    }

            return { success: false, message: obj2 };
        }
    };
};

export const otpEncryption = (otpvalue) => {
        try {
            // var otpInt = parseInt(otpvalue);
            jsencrypt.setPublicKey(config.PUBLIC_KEY);
            var encrypted = jsencrypt.encrypt(otpvalue);
        return encrypted;
        }
        catch (err) {
            // console.log(`Error message ${err}`)
        }
}


/////  TEMPLATE  //////////////////////////////////////

export const getTemplate = (key, value) => {
    return async (dispatch,getState)=>{
        let headers = { 
            // "clientId" : clientId,
            // "clientSecret":clientSecret,
            // "Authorization":`Bearer ${access_token}`
        }
        try{

            let resp = "";

            if(key == "clientId"){
                resp = await makeAPICall(`${config.GET_TEMPLATE_LIST}`,"GET", {}, headers)
            }else if(key == "consentGroupId"){
                resp = await makeAPICall(config.GET_TEMPLATE_BY_CONSENT_GROUPID+'?consentGroupId='+`${value}`,"GET", {}, headers)
            }

            
            let getTemplateList = resp.data
            dispatch({
                type: GET_TEMPLATE,
                getTemplateList,
            })
        }catch (error) {
           
            let obj1 = error.errorCd;
            let obj2 = error.errorMsg;

           

            if(obj2!==undefined){
               
            }else{
                toast.error(`Session Expired: Please login again`);
                sessionStorage.removeItem('sessionId');
                 window.location.href = '/login';
            }
            

            // throw new Error(`${obj2}`);
        }
        
    }
}

export const getDatatype = () => {
    return async (dispatch,getState)=>{
        // let clientId = getState().common.clientId;
        // let clientSecret = getState().common.clientSecret;
        // let access_token = getState().common.access_token;
        let headers = { 
            // "clientId" : clientId,
            // "clientSecret":clientSecret,
            // "Authorization":`Bearer ${access_token}`
        }
        try{
            let resp = await makeAPICall(config.GET_DATATYPE_LIST,"GET", {}, headers)
            // console.log(`Response getDatatype ${JSON.stringify(resp)}`);
            let getDatatypeList = resp.data
            if (getDatatypeList.length > 0) {
                getDatatypeList.sort(dynamicSort("dataType"));
            }
            // console.log(`Response getDatatype ${JSON.stringify(getDatatypeList)}`);
            dispatch({
                type: GET_DATATYPE,
                getDatatypeList,
            })
        }
        catch (error) {
            //console.log("ERROR IN ACTION", JSON.stringify(error));
            let obj1 = error.errorCd;
            let obj2 = error.errorMsg;

            //console.log("obj1 & obj2", obj1, obj2);

           if(obj2!==undefined){
        toast.error(`${obj2}`);
    }

            // throw new Error(`${obj2}`);
        }
       
    }
}

export const getPurpose = () => {
    return async (dispatch,getState)=>{
        // let clientId = getState().common.clientId;
        // let clientSecret = getState().common.clientSecret;

        // let access_token = getState().common.access_token;

        let headers = { 
            // "clientId" : clientId,
            // "clientSecret":clientSecret,
            // "Authorization":`Bearer ${access_token}`
        }
        try{
            let resp = await makeAPICall(config.GET_PURPOSE_LIST,"GET", {}, headers)
            // console.log(`Response getTemplate ${JSON.stringify(resp)}`);
            let getPurposeList = resp.data
            if (getPurposeList.length > 0) {
                getPurposeList.sort(dynamicSort("purpose"));
            }
            // console.log(`Response getPurpose ${JSON.stringify(getPurposeList)}`);
            dispatch({
                type: GET_PURPOSE,
                getPurposeList,
            })
        }
        catch (error) {
           // console.log("ERROR IN ACTION", JSON.stringify(error));
            let obj1 = error.errorCd;
            let obj2 = error.errorMsg;

           // console.log("obj1 & obj2", obj1, obj2);

           if(obj2!==undefined){
        toast.error(`${obj2}`);
    }

            // throw new Error(`${obj2}`);
        }
       
    }
}


export const getDashboard = () => {
    return async (dispatch,getState)=>{
        let headers = { 
            "checkcallfrom":"portal"
        }
        try{
            let resp = await makeAPICall(config.GET_DASHBOARD,"GET", {}, headers)
        let dashboarddata = resp.data
        let clientIdForDashboard = resp.config?.headers?.clientId || getState().common.clientId
        dispatch({
            type: DASHBOARD_DATA,
            dashboarddata,
            clientIdForDashboard
        })
        return { success: true, data: dashboarddata };

        }
        catch (error) {
            let obj1 = error.errorCd;
            let obj2 = error.errorMsg;

            if(obj2!==undefined){
                toast.error(`${obj2}`);
            }
            return { success: false, error };
        }
    }
}

export const getTemplatedetails = (item) => {
    return async (dispatch,getState)=>{
        // let clientId = getState().common.clientId;
        // let clientSecret = getState().common.clientSecret;

        // let access_token = getState().common.access_token;

        let headers = { 
            // "clientId" : clientId,
            // "clientSecret":clientSecret,    
            // "Authorization":`Bearer ${access_token}`
            // "clientSecret" :"25519c67-ccc1-4e0a-982f-ba7295ff994f",
            // "Authorization":"Bearer 3b96e7e6-114c-3adc-9a91-0654fcfae93a",
        }
        try{
            let resp = await makeAPICall(`${config.GET_TEMPLATE_DETAIL}/${item.templateId}`,"GET", {}, headers)
            // console.log(`Response getTemplate ${JSON.stringify(resp)}`);
            let getTemplateDetail = resp.data
            // console.log(`Response getTemplatedetails ${JSON.stringify(getTemplateDetail)}`);
            dispatch({
                type: TEMPLATE_DETAIL,
                getTemplateDetail,
            })
        }
        catch (error) {
           // console.log("ERROR IN ACTION", JSON.stringify(error));
            let obj1 = error.errorCd;
            let obj2 = error.errorMsg;

           // console.log("obj1 & obj2", obj1, obj2);

           if(obj2!==undefined){
        toast.error(`${obj2}`);
    }

            // throw new Error(`${obj2}`);
        }
        
    }
}

export const getConsentdetailsByTemplateId = (item) => {
    return async (dispatch,getState)=>{
        // let clientId = getState().common.clientId;
        // let clientSecret = getState().common.clientSecret;

        // let access_token = getState().common.access_token;
        
        let templateName = item.nickName;

        let headers = { 
            // "clientId" : clientId,
            // "clientSecret":clientSecret,    
            // "Authorization":`Bearer ${access_token}`
            // "clientSecret" :"25519c67-ccc1-4e0a-982f-ba7295ff994f",
            // "Authorization":"Bearer 3b96e7e6-114c-3adc-9a91-0654fcfae93a",
        }
        try{
            let resp = await makeAPICall(`${config.GET_CONSENT_DETAIL_TEMPLATE_ID}/${item.templateId}`,"GET", {}, headers)
            let getConsentDetail = resp.data
           // console.log("data consent: "+JSON.stringify(getConsentDetail));
            dispatch({
                type: CONSENT_DETAIL,
                getConsentDetail,
                templateName
            })
        }
        catch (error) {
           // console.log("ERROR IN ACTION", JSON.stringify(error));
            let obj1 = error.errorCd;
            let obj2 = error.errorMsg;

           // console.log("obj1 & obj2", obj1, obj2);

           if(obj2!==undefined){
        toast.error(`${obj2}`);
    }

            // throw new Error(`${obj2}`);
        }
        
    }
}

function dynamicSort(property) {
    var sortOrder = 1;
    if(property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a,b) {
        var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        return result * sortOrder;
    }
}

export const getEntityList = () => {
    return async (dispatch,getState)=>{
        
        // let access_token = getState().common.access_token;
        // let clientSecret = getState().common.clientSecret;

        let headers = { 
            // "Authorization":`Bearer ${access_token}`,
            // "clientSecret":clientSecret

        }
        try{
            let resp = await makeAPICall(config.GET_ENTITY_LIST,"GET", {}, headers)
            // console.log(`Response getEntityList ${JSON.stringify(resp)}`);
            let entityList = resp.data
            if (entityList.length > 0) {
                entityList.sort(dynamicSort("appName"));
            }
            // console.log(`Response entityList ${JSON.stringify(entityList)}`);
            dispatch({
                type: GET_ENTITY,
                entityList,
            })
        }
        catch (error) {
           // console.log("ERROR IN ACTION", JSON.stringify(error));
            let obj1 = error.errorCd;
            let obj2 = error.errorMsg;

           // console.log("obj1 & obj2", obj1, obj2);

            if(obj2!=undefined){
                toast.error(`${obj2}`);
            }else{
                toast.error(`Session Expired: Please login again`);
                sessionStorage.removeItem('sessionId');
                 window.location.href = '/login';
            }

            // throw new Error(`${obj2}`);
        }

        
    }
}


export const createTemplate = (body) => {
    return async (dispatch,getState)=>{

        try{

        const {consentMode,fetchType,consentTypes,dataTypes,dataConsumer,dataProvider,
            purpose,consentValidityUnit,consentValidityValue,DataLifeUnit,DataLifeValue,
            FrequencyUnit,FrequencyValue,nickName,format } = body
    
        // let clientId = getState().common.clientId;
        // let access_token = getState().common.access_token;
        // let clientSecret = getState().common.clientSecret;

        let headers = { 
            // "clientId" : clientId,
            // "clientSecret":clientSecret,
            "txnId": uuid(),
            // "Authorization":`Bearer ${access_token}`
        }
        let req = {
            "consentMode": consentMode,
            "fetchType": fetchType,
            "nickName": nickName,
            "consentTypes": consentTypes,
            "dataTypes": dataTypes,
            "dataConsumer": dataConsumer,
            "dataProvider": dataProvider,
            "purpose": {
             "purposeCode": "101",
            "text": purpose
            },
            "consentValidity": {
            "unit": consentValidityUnit,
            "value": consentValidityValue
            },
            "DataLife": {
            "unit": DataLifeUnit,
            "value": DataLifeValue
            },
            "Frequency": {
            "unit": FrequencyUnit,
            "value": FrequencyValue
            },
            "timestamp": timestamp,
            "Format": `${format ? format :"html along with argument sequence." }`,
            "FIDataRange": {
            "from": start,
            "to": end
            }
        }

        // let resp = await makeAPICall(config.ONBOARD_LIST_TEMPLATE,"POST", req, headers)
        // dispatch({
        //     type: ONBOARD_TEMPLATE,
        //     getonboardResponse,
        // })
      
        let resp = await makeAPICall(config.CREATE_TEMPLATE,"POST", req, headers)
        //console.log(`Response getonboardResponse ${JSON.stringify(resp)}`);
        let getOnboardResponse =  resp.data;
        // dispatch({
        //     type: ONBOARD_TEMPLATE,
        //     getOnboardResponse,
        // })

        return getOnboardResponse;

    }catch (error) {
       // console.log("ERROR IN ACTION", JSON.stringify(error));
        let obj1 = error.errorCd;
        let obj2 = error.errorMsg;

       // console.log("obj1 & obj2", obj1, obj2);

       if(obj2!==undefined){
        toast.error(`${obj2}`);
    }

        // throw new Error(`${obj2}`);
    }
        // let getonboardResponse = resp.data
    
        // console.log(`Response onboardResponse ${JSON.stringify(getonboardResponse)}`);

        // dispatch({
        //     type: ONBOARD_TEMPLATE,
        //     getonboardResponse,
        // })

        //let onboardList = resp.data
        // let resp = await makeAPICall(config.CREATE_TEMPLATE,"POST", req, headers)
        // console.log(`Response getTemplate ${JSON.stringify(resp)}`);
        // let getPurposeList = resp.data
        // console.log(`Response getPurpose ${JSON.stringify(getPurposeList)}`);
        // dispatch({
        //     type: CREATE_PURPOSE,
        //     getPurposeList,
        // })
    }
}


export const createConsentGroup = (req) => {
    return async (dispatch,getState)=>{

        try{
    
        let headers = { 
            // "clientId" : clientId,
            // "clientSecret":clientSecret,
            // "txnId": uuid(),
            // "Authorization":`Bearer ${access_token}`
        }
        //alert("a"+config.CREATE_CONSENT_GROUP);
        let resp = await makeAPICall(config.CREATE_CONSENT_GROUP,"POST", req, headers)
       // alert(`Response CREATE_CONSENT_GROUP ${JSON.stringify(resp)}`);
        let getCreateConsentGroupResponse =  resp.data;

        dispatch({
            type:GET_CREATE_CONSENT_GROUP_RESPONSE,
            getCreateConsentGroupResponse
        })


    }catch (error) {
        //console.log("ERROR IN ACTION", JSON.stringify(error));
        let obj1 = error.errorCd;
        let obj2 = error.errorMsg;

       // console.log("obj1 & obj2", obj1, obj2);

       if(obj2!==undefined){
        toast.error(`${obj2}`);
    }

        // throw new Error(`${obj2}`);
    }

    }
}



// For Update the Already Created Consent Group
export const update_Consent_Group = (req,groupID) => {
    return async (dispatch,getState)=>{

        try{
    
        let headers = { 
            "action": "DRAFT",
            "consentGroupID":groupID,
        }
        //alert("a"+config.CREATE_CONSENT_GROUP);
        let resp = await makeAPICall(config.CREATE_CONSENT_GROUP,"PUT", req, headers)
        
       // alert(`Response CREATE_CONSENT_GROUP ${JSON.stringify(resp)}`);
        let getUpdateConsentGroupResponse =  resp.data;

        dispatch({
            type:GET_UPDATED_CONSENT_GROUP_RESPONSE,
            getUpdateConsentGroupResponse
        })


    }catch (error) {
       // console.log("ERROR IN ACTION", JSON.stringify(error));
        let obj1 = error.errorCd;
        let obj2 = error.errorMsg;

       // console.log("obj1 & obj2", obj1, obj2);

       if(obj2!==undefined){
        toast.error(`${obj2}`);
    }

        // throw new Error(`${obj2}`);
    }

    }
}






export const createDatatype = (dataType,format,consentType) => {
    return async (dispatch,getState)=>{
        let today = new Date();
        let timestamp = today.toISOString();

        // let clientId = getState().common.clientId;
        // let clientSecret = getState().common.clientSecret;

        // let access_token = getState().common.access_token;

        let headers = { 
            // "clientId" : clientId,
            // "clientSecret":clientSecret,
            // "Authorization":`Bearer ${access_token}`
        }
        let req = {
            "dataType": dataType,
            "consentType": consentType,
            "dataFormat":"xsd",
            "timestamp": timestamp
            }
        try{
            await makeAPICall(config.CREATE_DATATYPE,"POST", req, headers)
        }catch (error) {
           // console.log("ERROR IN ACTION", JSON.stringify(error));
            let obj1 = error.errorCd;
            let obj2 = error.errorMsg;

           // console.log("obj1 & obj2", obj1, obj2);

           if(obj2!==undefined){
        toast.error(`${obj2}`);
    }

            // throw new Error(`${obj2}`);
        }
        // let resp = await makeAPICall(config.CREATE_DATATYPE,"POST", req, headers)
        // console.log(`Response getTemplate ${JSON.stringify(resp)}`);
        // let getPurposeList = resp.data
        // console.log(`Response getPurpose ${JSON.stringify(getPurposeList)}`);
        // dispatch({
        //     type: CREATE_PURPOSE,
        //     getPurposeList,
        // })
    }
}

export const createPurpose = (name,desc) => {
    return async (dispatch,getState)=>{

        // let clientId = getState().common.clientId;
        // let clientSecret = getState().common.clientSecret;
        // let access_token = getState().common.access_token;

        let req ={
            "purpose": name,
            "purposeDesc": desc
            }
        let headers = { 
            // "clientId" : clientId,
            // "clientSecret":clientSecret,
            // "Authorization":`Bearer ${access_token}`

        }
        try {
        await makeAPICall(config.CREATE_PURPOSE,"POST", req, headers)
        }catch (error) {
            // console.log("ERROR IN ACTION", JSON.stringify(error));
             let obj1 = error.errorCd;
             let obj2 = error.errorMsg;
 
            // console.log("obj1 & obj2", obj1, obj2);
 
            if(obj2!==undefined){
         toast.error(`${obj2}`);
     }
 
             // throw new Error(`${obj2}`);
         }
    }
}

export const getTempDetail = (tempId) =>{
    return async (dispatch,getState)=>{

        // let tempId = getState().common.tempId;
        // let clientId = getState().common.clientId;
        // let access_token = getState().common.access_token;
        // let clientSecret = getState().common.clientSecret;

        // let clientSecret = "ff8d0e98-2175-4f53-8152-dfc9d8373dd1";

        var headers = { 
            // "clientId":clientId,
            // "clientSecret": clientSecret,
            // "Authorization":`Bearer ${access_token}`

        }
        try {
            let resp = await makeAPICall(config.GET_TEMPLATE_DETAIL+`/${tempId}`, "GET", {}, headers);
           // console.log('value of GetTempDetail resp ' +  JSON.stringify(resp))
            // eslint-disable-next-line
            let data = resp.data
            // let clientId = data.clientId
            // console.log('resp of template detail ' + JSON.stringify(data))
           
        } catch (error) {
           // console.log("ERROR IN ACTION", JSON.stringify(error));
            let obj1 = error.errorCd;
            let obj2 = error.errorMsg;

           // console.log("obj1 & obj2", obj1, obj2);

           if(obj2!==undefined){
        toast.error(`${obj2}`);
    }

            // throw new Error(`${obj2}`);
        }
       
    }
}


export const getProfileData = (clientId) => {

   //alert("client Id is called "+clientId);

    return async (dispatch,getState)=>{
        // let clientId = getState().common.clientId;
        // let clientSecret = getState().common.clientSecret;
        // let access_token = getState().common.access_token;

        let headers = { 
            // "clientId" : clientId,
            // "clientSecret":clientSecret,
            // "Authorization":`Bearer ${access_token}`
        }
        let resp = await makeAPICall(config.GET_PROFILE_DATA+`/${clientId}`,"GET", {}, headers)
        //console.log(`Response getProfileData ${JSON.stringify(resp)}`);
        let profileData = resp.data
       // console.log(`Response profileData ${JSON.stringify(profileData)}`);

        const appName=resp.data.appName;
        //console.log(`Response Appname----. `+appName);
        const Logo=resp.data.logo;

        // let logoBase64 = resp.data.logo;
        // console.log("logoBase64 :"+logoBase64);

        // base64ToImage(logoBase64)
        //     .then((image) => {
        //         console.log(image);
        //     })
        //     .catch((error) => {
        //         // An error occurred while loading the image
        //         console.error(error);
        //     });

        dispatch({
            type: PROFILE_DATA,
            profileData
        })
        dispatch({
            type: APP_NAME,
            appName
        })
        dispatch({
            type: APP_LOGO,
            Logo
        })
        
    }
}

export const getConsentGroupData = (clientId) => {

    //alert("client Id is called "+clientId);
 
     return async (dispatch,getState)=>{
         // let clientId = getState().common.clientId;
         // let clientSecret = getState().common.clientSecret;
         // let access_token = getState().common.access_token;
 
         let headers = { 
             // "clientId" : clientId,
             // "clientSecret":clientSecret,
             // "Authorization":`Bearer ${access_token}`
         }
         try {
         let resp = await makeAPICall(config.GET_CONSENT_GROUP,"GET", {}, headers)
         //let resp = await makeAPICall(config.GET_CONSENT_GROUP+'?clientId='+`${clientId}`,"GET", {}, headers)
         //let resp = await makeAPICall('http://10.162.6.84:9025/v1.5/consent/getConsentGroup?clientId='+`${clientId}`,"GET", {}, headers)
         //console.log(`Response getConsentGroupData ${JSON.stringify(resp)}`);
         let data = resp.data
       // alert(`Response getConsentGroupData---------------------> ${JSON.stringify(data)}`);
         
         dispatch({
            type:GET_CONSENT_GROUP_DATA,
            data
        })
    }catch (error) {
        //console.log("ERROR IN ACTION", JSON.stringify(error));
        let obj1 = error.errorCd;
        let obj2 = error.errorMsg;

        //console.log("obj1 & obj2", obj1, obj2);

        if(obj2!==undefined){
            //toast.error(`${obj2}`);
        }else{
            toast.error(`Session Expired: Please login again`);
            sessionStorage.removeItem('sessionId');
             window.location.href = '/login';
        }

        // throw new Error(`${obj2}`);
    }
     }
 }

export const updateLogo = (request) => {

   // alert("client Id: "+request.clientId);
   // alert("image: "+request.base64Image);

    return async (dispatch,getState)=>{
        // let clientId = getState().common.clientId;
        // let clientSecret = getState().common.clientSecret;
        // let access_token = getState().common.access_token;

        let headers = { 
            // "clientId" : clientId,
            // "clientSecret":clientSecret,
            // "Authorization":`Bearer ${access_token}`
        }
        let resp = await makeAPICall(config.UPDATE_CLIENT_LOGO,"POST", request, headers)
        let respProfile = await makeAPICall(config.GET_PROFILE_DATA+`/${request.clientId}`,"GET", {}, headers)
        //console.log(`Response getProfileData ${JSON.stringify(resp)}`);
        let profileData = respProfile.data
        dispatch({
            type: PROFILE_DATA,
            profileData
        })
     
        
    }
}

function base64ToImage(base64String) {
    const decodedString = atob(base64String); // Decode the Base64 string
    const imageLink = decodedString.trim(); // Extract the link and remove any leading/trailing whitespace
    
    const image = new Image();
    image.src = imageLink;
  
    // Wait for the image to load
    return new Promise((resolve, reject) => {
      image.onload = () => {
        resolve(image);
      };
      image.onerror = (error) => {
        reject(error);
      };
    });
  }
  let data = [];
  export const getConsentDataFromJsonList = (consentDetailList) => {
    data = [];

    return async (dispatch,getState)=>{
    //alert(JSON.stringify(consentDetailList));
    for(let i=0; i<consentDetailList.length; i++){
     

      const consentStart = new Date(consentDetailList[i].consentStart);
      const consentExpiry = new Date(consentDetailList[i].consentExpiry)
      const formattedConsentStart = consentStart.toLocaleDateString() + ' ' + consentStart.toLocaleTimeString();
      const formattedConsentExpiry = consentExpiry.toLocaleDateString() + ' ' + consentExpiry.toLocaleTimeString();

      let consentObj = {
        srno:i+1,
        customerId:consentDetailList[i].customerId,
        consentId:consentDetailList[i].consentId,
        dataSharedWith:consentDetailList[i].dataConsumer,
        purpose:consentDetailList[i].purpose.text,
        createdOn:formattedConsentStart,
        modifiedOn:formattedConsentStart,
        expiry:formattedConsentExpiry,
        status:consentDetailList[i].status
      }

      data.push(consentObj);
     // alert(JSON.stringify(data));

    }

    dispatch({
        type: CONSENT_DATA_ARRAY,
        data
    })
    }
  };  

  export const updatePreferenceCenter = (theme,perferenceCenterData,consentGroupId,clientIdParam,topDescription,middleDescription,bottomDescription) => {
    return async (dispatch,getState)=>{
        
        let clientId = clientIdParam || getState().common.clientId;
        
        const stripHtml = (value) => (value || '').toString().replace(/<\/?[^>]+(>|$)/g, '').trim();
        const cleanedTop = stripHtml(topDescription);
        const cleanedMiddle = stripHtml(middleDescription);
        const cleanedBottom = stripHtml(bottomDescription);

        let headers = {}
        if(perferenceCenterData == null){
            let req ={
                "clientId":clientId,
                "consentGroupId":consentGroupId,
                "theme" : base64.encode(JSON.stringify(theme)),
                }
            if (cleanedTop) {
                req.topDescription = cleanedTop;
            }
            if (cleanedMiddle) {
                req.middleDescription = cleanedMiddle;
            }
            if (cleanedBottom) {
                req.bottomDescription = cleanedBottom;
            }
            await makeAPICall(config.UPDATE_PREFERENCE_CENTER,"POST", req, headers)
        }else{
            let req ={
                "theme" : base64.encode(JSON.stringify(theme)),
                }
            // Only send real descriptions — never placeholder strings that poison consentText
            if (cleanedTop) {
                req.topDescription = cleanedTop;
            }
            if (cleanedMiddle) {
                req.middleDescription = cleanedMiddle;
            }
            if (cleanedBottom) {
                req.bottomDescription = cleanedBottom;
            }
            await makeAPICall(config.UPDATE_PREFERENCE_CENTER+`/${consentGroupId}`,"PUT", req, headers)
        }
    }
}

export const updateConsentGroup = (consentNoticeArr, consentGroupName, consentGroupId, templates, description,middleDescription,bottomDescription,) => {
    return async (dispatch,getState)=>{

       // alert("templates in last ->"+JSON.stringify(templates));

         let req ={
            "consentGroupName": consentGroupName,
            "consentNotice": consentNoticeArr,
            // "topDescription":description,
            // "middleDescription":middleDescription,
            // "bottomDescription":bottomDescription,
            "consentText": {    
            "header": (description || '').toString().replace(/<\/?[^>]+(>|$)/g, '').trim(),    
            "description": (middleDescription || '').toString().replace(/<\/?[^>]+(>|$)/g, '').trim(),
            "footer": (bottomDescription || '').toString().replace(/<\/?[^>]+(>|$)/g, '').trim(),
            },
            "templates": templates,
            }

       // console.log("final request is --->"+JSON.stringify(req));
 
         var headers = { 
            "action": "PUBLISHED",
            "consentGroupID":consentGroupId
         }
        // console.log("final request is --->"+JSON.stringify(headers));
         try {
             let resp = await makeAPICall(config.UPDATE_CONSENT_GROUP_DETAILS, "PUT", req, headers);
             //alert('value of getPreferenceCenterThemeByClient resp ' +  JSON.stringify(resp))
             let data = resp.data
             dispatch({
                 type: UPDATE_CONSENT_GROUP,
                 data
             })
             return { success: true, data };
 
           // alert('response from put -------> ' +  JSON.stringify(data))
 
             dispatch({
                 type:UPDATE_CONSENT_GROUP,
                 data
             })
         } catch (error) {
           // console.log("ERROR IN ACTION", JSON.stringify(error));
            let obj2 = error.errorMsg || error.message || "Unable to publish Consent Group. Please try again.";
            // publish failure path for UPDATE_CONSENT_GROUP_DETAILS
            if (obj2 !== undefined) {
                toast.error(`${obj2}`);
            }
            return { success: false, error };
         }
     }
}

export const getPreferenceCenterThemeByClient = async (selectedConsentGroupId) => {
       // alert("in getPreferenceCenterThemeByClient");
       let storedData = store.getState().common
       let access_token = storedData.access_token;

        var headers = { 
            // "clientId":clientId,
            // "Authorization":`Bearer ${access_token}`
        }
        try {
            let resp = await makeAPICall(config.UPDATE_PREFERENCE_CENTER+`/${selectedConsentGroupId}`, "GET", {}, headers);
            //alert('value of getPreferenceCenterThemeByClient resp ' +  JSON.stringify(resp))
            let data = resp.data.theme

            console.log('data ' +  JSON.stringify(data))

            // dispatch({
            //     type:GET_PREFERENCE_CENTER_DATA,
            //     data
            // })
            return data;
        } catch (error) {
           // console.log("ERROR IN ACTION", JSON.stringify(error));
            let obj1 = error.errorCd;
            let obj2 = error.errorMsg;

           // console.log("obj1 & obj2", obj1, obj2);

           if(obj2!==undefined){
        toast.error(`${obj2}`);
    }

            // throw new Error(`${obj2}`);
        }
       
  

}


export const getconsentGroupDataByGroupId = async (consentGroupId) =>{

    

       //alert("in getPreferenceCenterThemeByClient");
       let storedData = store.getState().common
        let access_token = storedData.access_token;

        var headers = {
            // "clientId":clientId,
            // "Authorization":`Bearer ${access_token}`
        }
        try {
            let resp = await makeAPICall(config.GET_CONSENT_GROUP+'?consentGroupId='+`${consentGroupId}`, "GET", {}, headers);
            let data = resp.data

            // dispatch({
            //     type:GET_CONSENTGROUPDATABY_GROUPID,
            //     data
            // })

            //alert("data : "+JSON.stringify(data));
            return data;
        } catch (error) {
           // console.log("ERROR IN ACTION", JSON.stringify(error));
            let obj1 = error.errorCd;
            let obj2 = error.errorMsg;

           // console.log("obj1 & obj2", obj1, obj2);

           if(obj2!==undefined){
        toast.error(`${obj2}`);
    }

            // throw new Error(`${obj2}`);
        }
       
     

}



export const getTemplateDetailByTemplateId = (tempid) =>{

    return async (dispatch,getState)=>{

       //alert("in getPreferenceCenterThemeByClient");
        let access_token = getState().common.access_token;

        var headers = {
            // "clientId":clientId,
            // "Authorization":`Bearer ${access_token}`
        }
        try {
            let resp = await makeAPICall(config.GET_TEMPLATE_DETAIL_TEMPLATE_ID+`/${tempid}`, "GET", {}, headers);
            //alert('value of getPreferenceCenterThemeByClient resp ' +  JSON.stringify(resp))
            let data = resp.data
           // console.log(`Response getTemplateDetailByTemplateId---------------------> ${JSON.stringify(data)}`);
           //alert('data ' +  JSON.stringify(data))

            dispatch({
                type:GET_TEMPLATE_DETAIL_BY_TEMPLATEID,
                data
            })
        } catch (error) {
           // console.log("ERROR IN ACTION", JSON.stringify(error));
            let obj1 = error.errorCd;
            let obj2 = error.errorMsg;

           // console.log("obj1 & obj2", obj1, obj2);

           if(obj2!==undefined){
        toast.error(`${obj2}`);
    }

            // throw new Error(`${obj2}`);
        }
       
    }

}




export const changeProductTheme = (color) =>{
    return async (dispatch,getState)=>{

        // alert("in getPreferenceCenterThemeByClient");
         let access_token = getState().common.access_token;

         let req ={
            "theme" : color
            }
 
         var headers = { 
             // "clientId":clientId,
             // "Authorization":`Bearer ${access_token}`
         }
         try {
             let resp = await makeAPICall(config.changeTheme, "PUT", req, headers);
             //alert('value of getPreferenceCenterThemeByClient resp ' +  JSON.stringify(resp))
             let data = resp.data
 
            //alert('data ' +  JSON.stringify(data))
 
             dispatch({
                 type:PRODUCT_THEME,
                 data
             })
         } catch (error) {
           // console.log("ERROR IN ACTION", JSON.stringify(error));
            let obj1 = error.errorCd;
            let obj2 = error.errorMsg;

           // console.log("obj1 & obj2", obj1, obj2);

            if(obj2!==undefined){
                toast.error(`${obj2}`);
            }

            // throw new Error(`${obj2}`);
        }
        
     }
}


export const getProductThemeData = (color) =>{
    return async (dispatch,getState)=>{

        // alert("in getPreferenceCenterThemeByClient");
         let access_token = getState().common.access_token;

       
 
         var headers = { 
             // "clientId":clientId,
             // "Authorization":`Bearer ${access_token}`
         }
         try {
             let resp = await makeAPICall(config.changeTheme, "GET", {}, headers);
             //alert('value of getPreferenceCenterThemeByClient resp ' +  JSON.stringify(resp))
             let data = resp.data
 
          //  alert('data ' +  JSON.stringify(data))
 
             dispatch({
                 type:GET_PRODUCT_THEME,
                 data
             })
         } catch (error) {
           // console.log("ERROR IN ACTION", JSON.stringify(error));
            let obj1 = error.errorCd;
            let obj2 = error.errorMsg;

           // console.log("obj1 & obj2", obj1, obj2);

            if(obj2!==undefined){
                toast.error(`${obj2}`);
            }

            // throw new Error(`${obj2}`);
        }
        
     }
}

export const getFAQs = () =>{
    return async (dispatch,getState)=>{

        // alert("in getPreferenceCenterThemeByClient");
         let access_token = getState().common.access_token;

       
 
         var headers = { 
             // "clientId":clientId,
             // "Authorization":`Bearer ${access_token}`
         }
         try {
             let resp = await makeAPICall(config.GET_FAQ, "GET", {}, headers);
             //alert('value of getPreferenceCenterThemeByClient resp ' +  JSON.stringify(resp))
             let data = resp.data
 
          //  alert('data ' +  JSON.stringify(data))
 
             dispatch({
                 type:GET_FAQ_DATA,
                 data
             })
         } catch (error) {
           // console.log("ERROR IN ACTION", JSON.stringify(error));
            let obj1 = error.errorCd;
            let obj2 = error.errorMsg;

           // console.log("obj1 & obj2", obj1, obj2);

           if(obj2!==undefined){
        toast.error(`${obj2}`);
    }

            // throw new Error(`${obj2}`);
        }
        
     }
}



export const getTemplateDetailByConsentGroupId = (consentGroupId) =>{

    return async (dispatch,getState)=>{

       //alert("in getTemplateDetailByConsentGroupId");
        let access_token = getState().common.access_token;

        var headers = {
            // "clientId":clientId,
            // "Authorization":`Bearer ${access_token}`
        }
        try {
            // let resp = await makeAPICallGroupDataById(config.GET_CONSENTGROUPID+`/${consentGroupId}`, "GET", {}, headers);
            // console.log('Response in getconsentGroupDataByGroupId ACTION 1 '+JSON.stringify(resp))
            // //alert('value of getPreferenceCenterThemeByClient resp ' +  JSON.stringify(resp))
            // let data = resp.data

            
                let respTemp = await makeAPICall(config.GET_TEMPLATE_BY_CONSENT_GROUPID+'?consentGroupId='+`${consentGroupId}`, "GET", {}, headers);
                console.log('Response in getconsentGroupDataByGroupId ACTION IF 2 '+JSON.stringify(respTemp))
                //alert('value of getPreferenceCenterThemeByClient resp ' +  JSON.stringify(resp))
                let templates = respTemp.data
                //data.templateIds=templates  
            

            //alert('value of getConsentGroupDataByGroupId in commonaction '+JSON.stringify(data))
           // alert(`Response getConsentGroupDataByGroupId---------------------> ${JSON.stringify(data)}`);
           // alert('data ' +  JSON.stringify(data))

            dispatch({
                type:TEMPLATE_DETAIL_BY_SELECTED_CONSENTGROUP,
                templates
            })
        } catch (error) {
           // console.log("ERROR IN ACTION", JSON.stringify(error));
            let obj1 = error.errorCd;
            let obj2 = error.errorMsg;

           // console.log("obj1 & obj2", obj1, obj2);

           if(obj2!==undefined){
        toast.error(`${obj2}`);
    }

            // throw new Error(`${obj2}`);
        }
       
    }

}


export const cookieScanner = (url) => {
    return async (dispatch,getState)=>{

         let access_token = getState().common.access_token;
         var headers = {}
         try {
            let req ={
                "url":url,
            }

            let resp = await scanApiCall(config.SCAN_COOKIES, "POST", req, headers);

           // console.log("resp of cookie scanning  : "+JSON.stringify(resp));

            //  dispatch({
            //       type:SCANNED_COOKIE_DATA,
            //       resp
            //  })

             dispatch({
                type:SCANNED_COOKIE_RESP,
                resp
            })


         } catch (error) {
           // console.log("ERROR IN ACTION", JSON.stringify(error));
            let obj1 = error.errorCd;
            let obj2 = error.errorMsg;

           // console.log("obj1 & obj2", obj1, obj2);

           if(obj2!==undefined){
        toast.error(`${obj2}`);
    }

            // throw new Error(`${obj2}`);
        }
        
     }
}

export const getScannedStatusForReport = (scannedTransactionId) => {
    return async (dispatch,getState)=>{

      // alert("is called");

        let access_token = getState().common.access_token;
        var headers = {}
        try {

           let resp = await scanApiCall(config.COOKIE_SCANNING_STATUS_REPORT+"/"+scannedTransactionId, "GET", {}, headers);

          // console.log("resp of cookie scanning status  report : "+JSON.stringify(resp));
            dispatch({
                 type:SCANNED_COOKIE_DATA,
                 resp
            })


        } catch (error) {
           // console.log("ERROR IN ACTION", JSON.stringify(error));
            let obj1 = error.errorCd;
            let obj2 = error.errorMsg;

           // console.log("obj1 & obj2", obj1, obj2);

           if(obj2!==undefined){
        toast.error(`${obj2}`);
    }

            // throw new Error(`${obj2}`);
        }
       
    }
    

}

export const callDescriptionAPI = (cookiesArr) => {

    return async (dispatch,getState)=>{

        //alert("calling description api");

        let access_token = getState().common.access_token;
        var headers = { 
            // "clientId":clientId,
            // "Authorization":`Bearer ${access_token}`
        }
        try {

           let req ={
               "cookieDetails":cookiesArr,
           }

           //alert("calling scanner api with : "+JSON.stringify(req))

           let resp = await makeAPICall(config.fetchCookieDetailsbyCookieName, "POST", req, headers);

          // console.log("resp of fetchCookieDetailsbyCookieName  : "+JSON.stringify(resp));

            dispatch({
               type:COOKIE_DETAIL_WITH_DESCRIPTION,
               resp
           })


        } catch (error) {
           // console.log("ERROR IN ACTION", JSON.stringify(error));
            let obj1 = error.errorCd;
            let obj2 = error.errorMsg;

           // console.log("obj1 & obj2", obj1, obj2);

           if(obj2!==undefined){
        toast.error(`${obj2}`);
    }

            // throw new Error(`${obj2}`);
        }
       
    }

}

export const changeCookieScanURL = (url)=>{
    return async (dispatch,getState)=>{
        dispatch({
            type:COOKIE_SCAN_URL,
            changedUrl: url
        })
    }
}


export const postCookieScanReport = (request) => {

    return async (dispatch,getState)=>{

        let access_token = getState().common.access_token;
        var headers = { 
            // "clientId":clientId,
            // "Authorization":`Bearer ${access_token}`
            
        }
        try {
           let resp = await makeAPICall(config.POST_COOKIES_SCAN_REPORT, "POST", request, headers);

           //console.log("resp of POST_COOKIES_SCAN_REPORT  : "+JSON.stringify(resp));

            dispatch({
               type:POST_COOKIES_SCAN_REPORT_RESPONSE,
               resp
           })


        } catch (error) {
            //console.log("ERROR IN ACTION", JSON.stringify(error));
            let obj1 = error.errorCd;
            let obj2 = error.errorMsg;

           // console.log("obj1 & obj2", obj1, obj2);

           if(obj2!==undefined){
        toast.error(`${obj2}`);
    }

            // throw new Error(`${obj2}`);
        }
       
    }

}


// /getConsentLogs

export const getConsentLogs = () => {

   // alert("getConsentLogs");
    return async (dispatch,getState)=>{

        let access_token = getState().common.access_token;
        var headers = { 
            // "clientId":clientId,
            // "Authorization":`Bearer ${access_token}`
            
        }
        try {
           let resp = await makeAPICall(config.GET_COOKIE_CONSENT_LOGS, "GET", {}, headers);

          // console.log("resp of GET_COOKIE_CONSENT_LOGS  : "+JSON.stringify(resp));

            dispatch({
               type:COOKIE_CONSENT_LOGS,
               resp
           })


        } catch (error) {
           // console.log("ERROR IN ACTION", JSON.stringify(error));
            let obj1 = error.errorCd;
            let obj2 = error.errorMsg;

           // console.log("obj1 & obj2", obj1, obj2);

           if(obj2!==undefined){
        toast.error(`${obj2}`);
    }

            // throw new Error(`${obj2}`);
        }
       
    }

    // get help icons 

}

export const getConsentdetailsByCustomer = (customerId) => {

    //alert("customer :  "+customerId)
    return async (dispatch,getState)=>{

        let headers = { 
            // "clientId" :; clientId,
            // "clientSecret":clientSecret,    
            // "Authorization":`Bearer ${access_token}`
            // "clientSecret" :"25519c67-ccc1-4e0a-982f-ba7295ff994f",
            // "Authorization":"Bearer 3b96e7e6-114c-3adc-9a91-0654fcfae93a",
        };
        try{
            let customerIdHash=sha256(customerId);
           // console.log("customerIdHash no. hash",customerIdHash);
            let resp = await makeAPICall(config.GET_CONSENT_LIST_BY_CUST+'?customerId='+`${customerIdHash}&page=1`, "GET", null, headers)

            let consentList = resp.data
           // console.log("data consent: "+JSON.stringify(consentList));
            dispatch({
                type: CONSENT_LIST,
                consentList
            })
        }
        catch (error) {
           // console.log("ERROR IN ACTION", JSON.stringify(error));
            let obj1 = error.errorCd;
            let obj2 = error.errorMsg;

           // console.log("obj1 & obj2", obj1, obj2);

           if(obj2!==undefined){
        toast.error(`${obj2}`);
    }

            // throw new Error(`${obj2}`);
        }

        
    };
};

export const getVerfiybyConsentId = (item) => {
    return async (dispatch, getState) => {
        // let clientId = getState().common.clientId;
        // let clientSecret = getState().common.clientSecret;
        // let access_token = getState().common.access_token;

       
        let consentId = item;

        let headers = {


        }

        try {
            // Make the API call to verify the consentId using the appropriate API endpoint.
            let resp = await makeAPICall(`${config.VERIFY_CONSENT_ENDPOINT}/${consentId}`, "GET", {}, headers);
            let verifyResult = resp.data; // Assuming the API response contains the verification result.

           // console.log("Consent Verification Result: " + JSON.stringify(verifyResult));

            
            dispatch({
                type: CONSENT_VERIFICATION_RESULT,
                verifyResult,
            
            });
        } catch (error) {
           // console.log("ERROR IN ACTION", JSON.stringify(error));
            let obj1 = error.errorCd;
            let obj2 = error.errorMsg;

           // console.log("obj1 & obj2", obj1, obj2);

           if(obj2!==undefined){
        toast.error(`${obj2}`);
    }

            // throw new Error(`${obj2}`);
        }

        
    }
}

//createBulkConsents

export const createBulkConsents = (request) => {

    return async (dispatch,getState)=>{

        let access_token = getState().common.access_token;
        var headers = { 
            // "clientId":clientId,
            // "Authorization":`Bearer ${access_token}`
            "txnId":"3243453535435454"
        }

        let reqToSend = {
            "data":request
        }

        try {
           let resp = await makeAPICall(config.CREATE_BULK_CONSENT, "POST", reqToSend, headers);

          // console.log("resp of CREATE_BULK_CONSENT  : "+JSON.stringify(resp));

            dispatch({
               type:CREATE_BULK_CONSENT_RESPONSE,
               resp
           })


        } catch (error) {
           // console.log("ERROR IN ACTION", JSON.stringify(error));
            let obj1 = error.errorCd;
            let obj2 = error.errorMsg;

           // console.log("obj1 & obj2", obj1, obj2);

           if(obj2!==undefined){
        toast.error(`${obj2}`);
    }

            // throw new Error(`${obj2}`);
        }
       
    }
}
// export const  clearScannedCookieData= ()=>{
    
//     }

//API call for getGroups by groupid from navbar
export async function fetchGroupData(groupId, accountId) {
    const url = `http://10.162.6.84:10017/uam/v1.0/getGroups?groupId=${groupId}&accountId=${accountId}`;
   
    try {
        const response = await fetch(url);
   
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
   
        const data = await response.json();
        return data; // Return data to be used by the caller
   
    } catch (error) {
        console.error("Fetch error:", error);
        throw error; // Rethrow the error to be handled by the caller if necessary
    }
}

export const switchClients = (clientId, clientSecret, groupId) => {
    return async (dispatch, getState) => {
        dispatch({
            type:CLIENT_SWITCHED,
            selectedClientId:clientId,
            selectedClientSecret:clientSecret,
            selectedGroupId:groupId
        })
    }
}

//API call Dashboard of DSR
export const getDashboardDSR = () => {
    return async (dispatch,getState)=>{
        // let clientId = getState().common.clientId;
        // let clientSecret = getState().common.clientSecret;
        // let access_token = getState().common.access_token;

        let headers = { 
            //"clientId" : clientId,
            //"clientSecret":clientSecret,
            // "Authorization":`Bearer ${access_token}`
            //"checkcallfrom":"api"
        }
        let resp = await makeAPICall(config.GET_DASHBOARD_DSR,"GET", {}, headers)
        console.log("GET_DASHBOARD_DSR-->",resp.data);
        //console.log(`Response getDashboardDSR ${JSON.stringify(resp)}`);
        let dashboarddataDSR = resp.data
        let clientIdForDashboardDSR = resp.config.headers.clientId
        //console.log("clientIdForDashboardDSR : "+JSON.stringify(clientIdForDashboard));
        //console.log("Response getDashboardDataDSR :" +JSON.stringify(dashboarddataDSR));
        dispatch({
            type: DASHBOARD_DATA_DSR,
            dashboarddataDSR,
            clientIdForDashboardDSR
        })
     
        
    }
}

